//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('./BaseMediator')
const ClassFunc = require('../util/ClassFunc')
const GlobalFunc = require('../util/GlobalFunc')
const ObjectFunc = require('../util/ObjectFunc')
const Stats = require('../model/to/icehockey/Stats')

const stats = new Stats

/**
 * The OrganizationMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_PlayerStatsReportMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_PlayerStatsReportMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_PlayerStatsReportMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    destroy: function() {
        GlobalFunc.stopTimer(this)
    },
    handleDataLoaded: function(viewData) {
        // console.log('handleDataLoaded', this._bridge.getRouteName(), this.target())
        if (this._bridge.getRouteName() == 'PlayerStatsReport') {
            GlobalFunc.delayExecute(this, function() {
                this.target().changeTabName('PlayerStatsReportSummary')
            }, 100)
        }
        else {
            if (this.parent()) {
                GlobalFunc.delayExecute(this, function() {
                    this.parent().target().activeName = this._bridge.getRouteName()
                }, 100)
            }
            this.target().role = this._bridge.getRouteQuery('role')
        }
            
        if (this._bridge.getRouteName() == 'PlayerStatsReportSummary') {
            if (ObjectFunc.isEmpty(viewData.seasons)) {
                this.loadPromoStats()
            }
        }
        else if (this._bridge.getRouteName() == 'PlayerStatsReportStats') {
            // console.log('routeName PlayerStatsReportStats', this.target())
            const target = this.target()
            // console.log('validate target', target.group, target.popovers)
            if (target && target.group && target.popovers) {
                // console.log('target', target.group.stats.length, target.popovers.length)
                const length = target.group.stats.length
                if (!isNaN(target.popovers.length)) {
                    GlobalFunc.startTimer(this, function() {
                         // console.log('compare', target.popovers.length, length, this._bridge.getRouteName())
                        if (this._bridge.getRouteName() == 'PlayerStatsReportStats') {
                            if (target.popovers.length < length) {
                                target.popovers.push({})
                            }
                            else {
                                GlobalFunc.stopTimer(this)
                            }
                        }
                        else {
                            GlobalFunc.stopTimer(this)
                            this._bridge.refresh()
                        }
                    }, 3000)
                }   
            }
            else if (target.popovers == null) {
                this._bridge.refresh()
            }
        }
    },
    handleCustomizedEvent: function(event) {
        // console.log('handleCustomizedEvent', event)
        if (event.type == 'popup-service') {
            this.parent().target().popupService()
        }
        else if (event.type == 'order-service') {
            this.orderService(event.data)
        }
        else if (event.type == 'go-detail') {
            if (event.data.gameId) {
                this.goDetailPageByGameId(event.data)
            }
            else if (event.data.groupId) {
                this.goDetailPageByGroupId(event.data)
            }
        }
        else {
            return true
        }
    },
    loadPromoStats: function() {
        const self = this
        // load the promo stats data
        self.loadViewObjectData(self.convertor(), self._bridge.getRouteQuery(), function(viewData) {
            // console.log('load promo stats data', viewData)
            self.target().summary.season = viewData.stats.season
            self.target().summary.seasons = []
            // console.log('self.target().summary.season', self.target().summary.season)
            viewData.stats.season = null
            self.target().summary.stats = viewData.stats
            self.target().summary.rankings = viewData.rankings
        }, 'promo')
    },
    goDetailPageByGroupId: function(data) {
        const self = this
        self.loadViewObjectData(self.convertor(), data, function(viewData) {
            // console.log('go detail page map data', viewData)
            self.goDetailPageByGameId({type: 'group', gameId: viewData.gameId})
        }, 'find')
    },
    goDetailPageByGameId: function(data) {
        const self = this
        self.loadViewObjectData(self.convertor(), data, function(viewData) {
            // console.log('go detail page map data', viewData)
            if (viewData.gameId) {
                let path
                const query = {}
                if (data.type == 'game') {
                    path = '/pages/game/videoDetail'
                    query.id = viewData.gameId
                    query.sportType = stats.localeProp('icehockey')
                    query.current= data.current
                }
                else if (data.type == 'group') {
                    path = '/pages/game/index'
                    query.matchId = viewData.matchId
                }
                self.goToWXMPUrl(path, query)
            }
            else {
                self.target().showToast(stats.localeProp('none-valid-detail-page'))
            }
        }, 'map')
    },
    orderService: function(data) {
        const self = this
        self.commitViewObjectData(self.convertor(), data, function(e) {
            // console.log('@order-service', e)
            if (e.data.result) {
                const orderId = e.data.payload.data.orderId
                if (orderId) {
                    // console.log('go to pay for order', orderId)
                    self.goToWXMPUrl('/pages/game/h5pay', {orderId: orderId, redirectUrl: location.href})
                }
            }
        }, 'order')
    },
    handleViewDataWrap: function(viewData) {
        // console.log('handleViewDataWrap', viewData)
        if (this._bridge.getRouteName() == 'PlayerStatsReportGames' && viewData.games) {
            const games = []
            let currentLeagueId
            let currentSeason
            let currentGroupId
            for (let i = 0; i < viewData.games.length; i++) {
                let item = viewData.games[i]
                if (item.leagueId != currentLeagueId 
                    || item.season != currentSeason 
                    || item.groupId != currentGroupId) {
                    // merge the label for the match group
                    const label = item.season + '-' + (Number(item.season) + 1) + ' ' + item.league + ' ' + item.group + ' ' + item.team + ' ' + item.position
                    games.push({label: label, isGroup: true, groupId: item.groupId, gameId: item.gameId})
                    currentLeagueId = item.leagueId
                    currentSeason = item.season
                    currentGroupId = item.groupId
                }
                games.push(item)
            }
            // console.log('before set game for the target')
            this.target().game = {
                seasons: viewData.seasons,
                leagues: viewData.leagues,
                groups: viewData.groups,
                games: games
            }
            return false
        }
        else {
            return true
        }
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_PlayerStatsReportMediator, BaseMediator);

module.exports = tbs_controller_PlayerStatsReportMediator